import { render, staticRenderFns } from "./Prelims.vue?vue&type=template&id=cb858838&scoped=true"
import script from "./Prelims.vue?vue&type=script&lang=js"
export * from "./Prelims.vue?vue&type=script&lang=js"
import style0 from "./Prelims.vue?vue&type=style&index=0&id=cb858838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb858838",
  null
  
)

export default component.exports